import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
// Components
import Modal from '@/components/base/Modal';
import { Trans } from '@/components/tools/translation';

type ReportSuccessModalProps = {
    isOpen: boolean;
    toggle: () => void;
    isScheduled: boolean;
    isEdit: boolean;
};

const ReportSuccessModal = ({
    isOpen,
    toggle,
    isScheduled = false,
    isEdit = false
}: ReportSuccessModalProps) => {
    const { t } = useTranslation('reports');

    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>
                    {t(isEdit ? 'edit.title_edit_success' : 'create.title_download_success')}
                </Modal.Title>
                <Modal.Content className="pt-8 text-center text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {isEdit ? (
                        t('edit.text_edit_success')
                    ) : (
                        <Trans
                            i18nKey="reports:create.successfully_created_text"
                            components={{ br: <br /> }}
                            values={{
                                section_title: t(
                                    isScheduled
                                        ? 'general.scheduled_title'
                                        : 'general.history_title'
                                )
                            }}
                        />
                    )}
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer className="my-8 flex justify-center space-x-6">
                <Button onClick={toggle}>
                    {t(isEdit ? 'edit.submit_edit_success' : 'create.submit_download_success')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReportSuccessModal;
